import moment from "moment";
import { FAILURE, POST, PUT, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function obtenerListaProgramacionCamiones(
  obj,
  combo = false,
  tag,
) {
  try {
    let data = [];
    const { code, body } = await fetch(
      "https://gestiondeflota.boltrack.net/apiultimamillav3/api/programacion-camiones/obtener-lista-programacion-camiones",
      {
        headers: getHeaders(),
        method: POST,
        body: JSON.stringify(obj),
      },
    ).then((res) => res.json());
    // console.log('code');
    // console.log(code);
    // console.log('body');
    // console.log(body);
    if (code === SUCCESS) {
      // data.error = false;
      data = body;
      if (combo === false) {
        for (let i = 0; i < data.length; i++) {
          data[i].fechaProceso = moment(data[i].fechaProceso).format(
            "YYYY/MM/DD HH:mm",
          );
          data[i].habilitadoLabel =
            data[i].habilitado === 1
              ? tag("column_habilitado")
              : tag("column_deshabilitado");
        }
      }
      if (combo === true) {
        data = data.map((item) => {
          return {
            value: item.id,
            label: item.descripcion,
          };
        });
      }
    }
    console.log(data);
    return data;
  } catch (err) {
    console.log("obtenerListaProgramacionCamiones err");
    console.log(err);
    return [];
  }
}

export async function obtenerListaProgramacionCamionesPorFecha(
  obj,
  combo = false,
  tag,
) {
  try {
    let data = [];
    const { code, body } = await fetch(
      "https://gestiondeflota.boltrack.net/apiultimamillav3/api/programacion-camiones/obtener-lista-programacion-camiones-por-fecha",
      {
        headers: getHeaders(),
        method: POST,
        body: JSON.stringify(obj),
      },
    ).then((res) => res.json());
    if (code === SUCCESS) {
      data = Array.isArray(body) ? body : [];
      if (combo === false) {
        for (let i = 0; i < data.length; i++) {
          data[i].fechaProceso = moment(data[i].fechaProceso).format(
            "YYYY/MM/DD HH:mm",
          );
          data[i].habilitadoLabel =
            data[i].habilitado === 1
              ? tag("column_habilitado")
              : tag("column_deshabilitado");
        }
      }
      if (combo === true) {
        data = data.map((item) => ({
          value: item.id,
          label: item.descripcion,
        }));
      }
    }
    return data;
  } catch (err) {
    console.log("obtenerListaProgramacionCamionesPorFecha err");
    console.log(err);
    return [];
  }
}

export async function obtenerListaProgramacionCamionesAprobados(
  obj,
  combo = false,
  tag,
) {
  try {
    console.log(obj);
    let data = [];
    const { code, body } = await fetch(
      "https://gestiondeflota.boltrack.net/apiultimamillav3/api/programacion-camiones/obtener-lista-programacion-camiones-aprobados",
      {
        headers: getHeaders(),
        method: POST,
        body: JSON.stringify(obj),
      },
    ).then((res) => res.json());
    // console.log('code');
    // console.log(code);
    // console.log('body');
    // console.log(body);
    if (code === SUCCESS) {
      // data.error = false;
      data = body;
      if (combo === false) {
        for (let i = 0; i < data.length; i++) {
          data[i].fechaProceso = moment(data[i].fechaProceso).format(
            "YYYY/MM/DD HH:mm",
          );
          data[i].habilitadoLabel =
            data[i].habilitado === 1
              ? tag("column_habilitado")
              : tag("column_deshabilitado");
        }
      }
      if (combo === true) {
        data = data.map((item) => {
          return {
            value: item.id,
            label: item.descripcion,
          };
        });
      }
    }
    console.log(data);
    return data;
  } catch (err) {
    console.log("obtenerListaProgramacionCamionesAprobados err");
    console.log(err);
    return [];
  }
}

export async function crearProgramacionCamiones(obj) {
  try {
    let data = { error: true };
    const { code, message } = await fetch(
      "https://gestiondeflota.boltrack.net/apiultimamillav3/api/programacion-camiones/crear-programacion-camiones",
      {
        headers: getHeaders(),
        method: POST,
        body: JSON.stringify(obj),
      },
    ).then((res) => res.json());
    // console.log('code');
    // console.log(code);
    // console.log('body');
    // console.log(body);
    if (code === SUCCESS) {
      data.error = false;
    }
    if (code === FAILURE) {
      data.error = true;
      data.message = message;
    }
    return data;
  } catch (err) {
    console.log("crearProgramacionCamiones err");
    console.log(err);
    return { error: true, message: err };
  }
}

export async function actualizarProgramacionCamiones(obj) {
  try {
    let data = { error: true };
    const { code, message } = await fetch(
      "https://gestiondeflota.boltrack.net/apiultimamillav3/api/programacion-camiones/actualizar-programacion-camiones",
      {
        headers: getHeaders(),
        method: PUT,
        body: JSON.stringify(obj),
      },
    ).then((res) => res.json());
    // console.log('code');
    // console.log(code);
    // console.log('body');
    // console.log(body);
    if (code === SUCCESS) {
      data.error = false;
    }
    if (code === FAILURE) {
      data.error = true;
      data.message = message;
    }
    return data;
  } catch (err) {
    console.log("actualizarProgramacionCamiones err");
    console.log(err);
    return { error: true, message: err };
  }
}

export async function deshabilitarProgramacionCamiones(obj) {
  try {
    let data = { error: true };
    const { code, message } = await fetch(
      "https://gestiondeflota.boltrack.net/apiultimamillav3/api/programacion-camiones/deshabilitar-programacion-camiones",
      {
        headers: getHeaders(),
        method: PUT,
        body: JSON.stringify(obj),
      },
    ).then((res) => res.json());
    // console.log('code');
    // console.log(code);
    // console.log('body');
    // console.log(body);
    if (code === SUCCESS) {
      data.error = false;
    }
    if (code === FAILURE) {
      data.error = true;
      data.message = message;
    }
    return data;
  } catch (err) {
    console.log("deshabilitarProgramacionCamiones err");
    console.log(err);
    return { error: true, message: err };
  }
}

export async function habilitarProgramacionCamiones(obj) {
  try {
    let data = { error: true };
    const { code, message } = await fetch(
      "https://gestiondeflota.boltrack.net/apiultimamillav3/api/programacion-camiones/habilitar-programacion-camiones",
      {
        headers: getHeaders(),
        method: PUT,
        body: JSON.stringify(obj),
      },
    ).then((res) => res.json());
    // console.log('code');
    // console.log(code);
    // console.log('body');
    // console.log(body);
    if (code === SUCCESS) {
      data.error = false;
    }
    if (code === FAILURE) {
      data.error = true;
      data.message = message;
    }
    return data;
  } catch (err) {
    console.log("habilitarProgramacionCamiones err");
    console.log(err);
    return { error: true, message: err };
  }
}

/**
 * Actualiza el idEstadoViaje de una programacion de camiones.
 *
 * PUT /api/programacion-camiones/actualizar-id-estado-viaje-programacion-camiones
 * body: { id, idEstadoViaje }
 */
export async function actualizarIdEstadoViajeProgramacionCamiones(obj) {
  try {
    let data = { error: true };
    const { code, message, body } = await fetch(
      "https://gestiondeflota.boltrack.net/apiultimamillav3/api/programacion-camiones/actualizar-id-estado-viaje-programacion-camiones",
      {
        headers: getHeaders(),
        method: PUT,
        body: JSON.stringify(obj),
      },
    ).then((res) => res.json());

    if (code === SUCCESS) {
      data.error = false;
      data.data = body;
    }
    if (code === FAILURE) {
      data.error = true;
      data.message = message;
    }
    return data;
  } catch (err) {
    console.log("actualizarIdEstadoViajeProgramacionCamiones err");
    console.log(err);
    return { error: true, message: err };
  }
}

export async function aprobarProgramacionCamiones(obj) {
  try {
    let data = { error: true };
    const { code, message } = await fetch(
      "https://gestiondeflota.boltrack.net/apiultimamillav3/api/programacion-camiones/aprobar-programacion-camiones",
      {
        headers: getHeaders(),
        method: PUT,
        body: JSON.stringify(obj),
      },
    ).then((res) => res.json());
    if (code === SUCCESS) {
      data.error = false;
      data.message = message;
    }
    if (code === FAILURE) {
      data.error = true;
      data.message = message;
    }
    return data;
  } catch (err) {
    console.log("aprobarProgramacionCamiones err");
    console.log(err);
    return { error: true, message: err };
  }
}

export async function rechazarProgramacionCamiones(obj) {
  try {
    let data = { error: true };
    const { code, message } = await fetch(
      "https://gestiondeflota.boltrack.net/apiultimamillav3/api/programacion-camiones/rechazar-programacion-camiones",
      {
        headers: getHeaders(),
        method: PUT,
        body: JSON.stringify(obj),
      },
    ).then((res) => res.json());
    if (code === SUCCESS) {
      data.error = false;
      data.message = message;
    }
    if (code === FAILURE) {
      data.error = true;
      data.message = message;
    }
    return data;
  } catch (err) {
    console.log("rechazarProgramacionCamiones err");
    console.log(err);
    return { error: true, message: err };
  }
}

export async function crearProgramacionCamionesExternal(obj) {
  try {
    let data = { error: true };
    const { code, message } = await fetch(
      "https://gestiondeflota.boltrack.net/apiultimamillav3/api/programacion-camiones/crear-programacion-camiones-external",
      {
        headers: getHeaders(false),
        method: POST,
        body: JSON.stringify(obj),
      },
    ).then((res) => res.json());
    // console.log('code');
    // console.log(code);
    // console.log('body');
    // console.log(body);
    if (code === SUCCESS) {
      data.error = false;
    }
    if (code === FAILURE) {
      data.error = true;
      data.message = message;
    }
    return data;
  } catch (err) {
    console.log("crearProgramacionCamionesExternal err");
    console.log(err);
    return { error: true, message: err };
  }
}
